import { render, staticRenderFns } from "./DetectionCard.vue?vue&type=template&id=1c03c1da&"
import script from "./DetectionCard.vue?vue&type=script&lang=ts&"
export * from "./DetectionCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports